import { ILargeStorageConsumer, ILargeStorageConsumerRegistration } from "./large-storage-consumer.interface";
import {ILargeStorageConsumersManagerService} from "./large-storage-consumers-manager.service.interface";
import {ServiceBase} from "../service-base";

export class LargeStorageConsumersManagerService extends ServiceBase implements ILargeStorageConsumersManagerService {
    private _sessionStorageConsumers: ILargeStorageConsumer[] = [];
    registerSessionStorageConsumer(consumer: ILargeStorageConsumer): ILargeStorageConsumerRegistration {
        this._sessionStorageConsumers.push(consumer);
        return {
            unregister: () => {
                const index = this._sessionStorageConsumers.indexOf(consumer);
                if(index >= 0) {
                    this._sessionStorageConsumers.splice(index, 1);
                }
            }
        }
    }

    clearSessionStorageConsumers(): void {
        this._clearConsumers(this._sessionStorageConsumers);
    }

    private _localStorageConsumers: ILargeStorageConsumer[] = [];
    registerLocalStorageConsumer(consumer: ILargeStorageConsumer): ILargeStorageConsumerRegistration {
        this._localStorageConsumers.push(consumer);
        return {
            unregister: () => {
                const index = this._localStorageConsumers.indexOf(consumer);
                if(index >= 0) {
                    this._localStorageConsumers.splice(index, 1);
                }
            }
        }
    }

    clearLocalStorageConsumers(): void {
        this._clearConsumers(this._localStorageConsumers);
    }

    private _clearConsumers(consumers: ILargeStorageConsumer[]): void {
        for(let consumer of consumers) {
            try {
                consumer.clearUsedStorage();
            } catch (err) {
                this.services.logger.error(`Failed to clear session storage for consumer ${consumer}`, err);
            }

        }
    }

    clearAll() {
        this.clearSessionStorageConsumers();
        this.clearLocalStorageConsumers();
    }
}